import { axiosInstance } from '../Axios';
import { toggleEmployeeModal, toggleFileUploadModal } from 'reducers/UiReducer';
const { createSlice } = require('@reduxjs/toolkit');

// Utility Functions
const getAxiosConfig = (token) => ({
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		Authorization: `Bearer ${token}`,
	},
});

const getErrorMessage = (error) =>
	error.response && error.response.data.message
		? error.response.data.message
		: error.message;

// Slice Definition
const EmployeeReducer = createSlice({
	name: 'employee',
	initialState: {
		success: false,
		error: null,
		loadingCreateEmployee: false,
		createEmployeeData: null,
		loadingEmployeeList: false,
		loadingEmployeeFile: false,
		loadingSingleEmployee: false,
		employeeSingle: null,

		loadingDowloadFtpFile: false,
		employeeList: null,
		employeeSuccessMessage: '',
		employeeFile: null,

		loadingUpdateEmployee: false,
		loadingDeleteEmployee: false,
		loadingCreateEmployeeUser: false,
		loadingDeleteEmployeeFile: false,
		loadingRenewEmployeeFile: false,
		updateEmployeeData: null,

		loadingInsertAttachment: false,
		loadingUpdateAttachment: false,


		updateAttachmentData: null,
		insertAttachmentData: null,

		loadingDepartmentList: false,
		loadingDesignationList: false,
		departmentList: null,
		designationList: null,

		locationList: null,
		modelList: null,
		workList: null,
		activityList: null,
	},
	reducers: {
		// Create Employee
		createEmployeeRequest(state) {
			state.loadingCreateEmployee = true;
			state.error = null;
			state.employeeSuccessMessage = '';
		},
		createEmployeeSuccess(state, action) {
			state.loadingCreateEmployee = false;
			state.createEmployeeData = action.payload;
			state.error = null;
			state.success = true;
			state.employeeSuccessMessage = action.payload?.message || 'Employee saved successfully';
		},
		createEmployeeFail(state, action) {
			state.loadingCreateEmployee = false;
			state.error = action.payload;
			state.success = false;
		},
		// Get Employee List
		getEmployeeListRequest(state) {
			state.loadingEmployeeList = true;
		},
		getEmployeeListSuccess(state, action) {
			state.loadingEmployeeList = false;
			state.employeeList = action.payload;
			state.error = null;
		},
		getEmployeeListFail(state, action) {
			state.loadingEmployeeList = false;
			state.error = action.payload;
		},

		// Get Employee single
		getEmployeeSingleRequest(state) {
			state.loadingSingleEmployee = true;
		},
		getEmployeeSingleSuccess(state, action) {
			state.loadingSingleEmployee = false;
			state.employeeSingle = action.payload;
			state.error = null;
		},
		getEmployeeSingleFail(state, action) {
			state.loadingSingleEmployee = false;
			state.error = action.payload;
		},


		// Get Employee FileList
		getEmployeeFileRequest(state) {
			state.loadingEmployeeFile = true;
		},
		getEmployeeFileSuccess(state, action) {
			state.loadingEmployeeFile = false;
			state.employeeFile = action.payload;
			state.error = null;
		},
		getEmployeeFileFail(state, action) {
			state.loadingEmployeeFile = false;
			state.error = action.payload;
		},
		clearEmployeeFile(state) {
			state.employeeFile = { data: [] };
			state.loadingEmployeeFile = false;
			state.error = null;
		},

		// Dowload FTP File
		dowloadFtpFileRequest(state) {
			state.loadingDowloadFtpFile = true;
		},
		dowloadFtpFileSuccess(state, action) {
			state.loadingDowloadFtpFile = false;
			state.error = null;
			state.success = true;
		},
		dowloadFtpFileFail(state, action) {
			state.loadingDowloadFtpFile = false;
			state.error = action.payload;
		},
		// Update Employee
		updateEmployeeRequest(state) {
			state.loadingUpdateEmployee = true;
			state.error = null;
			state.employeeSuccessMessage = '';
		},
		updateEmployeeSuccess(state, action) {
			state.loadingUpdateEmployee = false;
			state.updateEmployeeData = action.payload;
			state.error = null;
			state.success = true;
			state.employeeSuccessMessage = action.payload?.message || 'Employee updated successfully';
		},
		updateEmployeeFail(state, action) {
			state.loadingUpdateEmployee = false;
			state.error = action.payload;
			state.success = false;
		},
		deleteEmployeeRequest(state) {
			state.loadingDeleteEmployee = true;
		},
		deleteEmployeeSuccess(state) {
			state.loadingDeleteEmployee = false;
			state.error = null;
			state.success = true;
		},
		deleteEmployeeFail(state, action) {
			state.loadingDeleteEmployee = false;
			state.error = action.payload;
			state.success = false;
		},
		createEmployeeUserRequest(state) {
			state.loadingCreateEmployeeUser = true;
			state.error = null;
			state.employeeSuccessMessage = '';
		},
		createEmployeeUserSuccess(state, action) {
			state.loadingCreateEmployeeUser = false;
			state.error = null;
			state.success = true;
			state.employeeSuccessMessage = action.payload?.message || 'Employee user created successfully';
		},
		createEmployeeUserFail(state, action) {
			state.loadingCreateEmployeeUser = false;
			state.error = action.payload;
			state.success = false;
		},

		// Update Attachment Update
		updateAttachmentUpdateRequest(state) {
			state.loadingUpdateAttachment = true;
		},
		updateAttachmentUpdateSuccess(state, action) {
			state.loadingUpdateAttachment = false;
			state.updateAttachmentData = action.payload;
			state.error = null;
			state.success = true;
		},
		updateAttachmentUpdateFail(state, action) {
			state.loadingUpdateAttachment = false;
			state.error = action.payload;
			state.success = false;
		},

		// Insert Attachment
		insertAttachmentRequest(state) {
			state.loadingInsertAttachment = true;
		},
		insertAttachmentSuccess(state, action) {
			state.loadingInsertAttachment = false;
			state.insertAttachmentData = action.payload;
			state.error = null;
			state.success = true;
		},
		insertAttachmentFail(state, action) {
			state.loadingInsertAttachment = false;
			state.error = action.payload;
			state.success = false;
		},


		// Delete Employee File
		deleteEmployeeFileRequest(state) {
			state.loadingDeleteEmployeeFile = true;
		},
		deleteEmployeeFileSuccess(state, action) {
			state.loadingDeleteEmployeeFile = false;
			state.error = null;
			state.success = true;
		},
		deleteEmployeeFileFail(state, action) {
			state.loadingDeleteEmployeeFile = false;
			state.error = action.payload;
			state.success = false;
		},

		// Renew Employee File
		renewEmployeeFileRequest(state) {
			state.loadingRenewEmployeeFile = true;
		},
		renewEmployeeFileSuccess(state, action) {
			state.loadingRenewEmployeeFile = false;
			state.error = null;
			state.success = true;
		},
		renewEmployeeFileFail(state, action) {
			state.loadingRenewEmployeeFile = false;
			state.error = action.payload;
			state.success = false;
		},
		// Get Department List
		getDepartmentListRequest(state) {
			state.loadingDepartmentList = true;
		},
		getDepartmentListSuccess(state, action) {
			state.loadingDepartmentList = false;
			state.departmentList = action.payload;
			state.error = null;
		},
		getDepartmentListFail(state, action) {
			state.loadingDepartmentList = false;
			state.error = action.payload;
		},
		// Get Department List
		getDesignationListRequest(state) {
			state.loadingDesignationList = true;
		},
		getDesignationListSuccess(state, action) {
			state.loadingDesignationList = false;
			state.designationList = action.payload;
			state.error = null;
		},
		getDesignationListFail(state, action) {
			state.loadingDesignationList = false;
			state.error = action.payload;
		},
		getLocationListRequest(state) {
			state.loadingLocationList = true;
		},
		getLocationListSuccess(state, action) {
			state.loadingLocationList = false;
			state.locationList = action.payload;
			state.error = null;
		},
		getLocationListFail(state, action) {
			state.loadingLocationList = false;
			state.error = action.payload;
		},



	},
});

const { actions } = EmployeeReducer;

export const {
	createEmployeeRequest,
	createEmployeeSuccess,
	createEmployeeFail,

	getEmployeeListRequest,
	getEmployeeListSuccess,
	getEmployeeListFail,

	getEmployeeSingleRequest,
	getEmployeeSingleSuccess,
	getEmployeeSingleFail,


	getEmployeeFileRequest,
	getEmployeeFileSuccess,
	getEmployeeFileFail,
	clearEmployeeFile,

	dowloadFtpFileRequest,
	dowloadFtpFileSuccess,
	dowloadFtpFileFail,

	updateEmployeeRequest,
	updateEmployeeSuccess,
	updateEmployeeFail,

	deleteEmployeeRequest,
	deleteEmployeeSuccess,
	deleteEmployeeFail,

	createEmployeeUserRequest,
	createEmployeeUserSuccess,
	createEmployeeUserFail,

	updateAttachmentUpdateRequest,
	updateAttachmentUpdateSuccess,
	updateAttachmentUpdateFail,

	insertAttachmentRequest,
	insertAttachmentSuccess,
	insertAttachmentFail,

	deleteEmployeeFileRequest,
	deleteEmployeeFileSuccess,
	deleteEmployeeFileFail,

	renewEmployeeFileRequest,
	renewEmployeeFileSuccess,
	renewEmployeeFileFail,

	getDepartmentListRequest,
	getDepartmentListSuccess,
	getDepartmentListFail,

	getDesignationListRequest,
	getDesignationListSuccess,
	getDesignationListFail,

	getLocationListRequest,
	getLocationListSuccess,
	getLocationListFail,


} = actions;


// Dispatch Functions
export const createEmployeeDispatch = (bodyData, token, navigate) => async (dispatch) => {
	try {
		dispatch(createEmployeeRequest());
		const { data } = await axiosInstance.post(
			'/Employee/CreateEmployee',
			bodyData,
			getAxiosConfig(token)
		);

		if (data.status === 1) {
			dispatch(createEmployeeSuccess(data));
			dispatch(getEmployeeListDispatch({ Offset: 0, RecordCount: 20, EmployeeCode: '' }, token));
			dispatch(toggleEmployeeModal(false));
			if (navigate) {
				navigate('/employee/list');
			}
		} else {
			dispatch(createEmployeeFail(data.message || 'Unable to create employee'));
		}
		return data;
	} catch (error) {
		dispatch(createEmployeeFail(getErrorMessage(error)));
		return {
			status: 0,
			message: getErrorMessage(error),
		};
	}
};

export const getEmployeeListDispatch = (bodyData, token) => async (dispatch) => {
	try {
		dispatch(getEmployeeListRequest());
		const employeeDto = bodyData?.employeeDto || {};
		const offset = bodyData?.Offset ?? bodyData?.offset ?? employeeDto.offset ?? 0;
		const recordCount =
			bodyData?.RecordCount ?? bodyData?.recordCount ?? employeeDto.recordCount ?? employeeDto.pageSize ?? 20;
		const employeeCode =
			bodyData?.EmployeeCode ?? bodyData?.employeeCode ?? employeeDto.EmployeeCode ?? employeeDto.employeeCode ?? '';

		const { data } = await axiosInstance.get('/Employee/GetEmployeeList', {
			...getAxiosConfig(token),
			params: {
				Offset: offset,
				RecordCount: recordCount,
				EmployeeCode: employeeCode,
			},
		});

		dispatch(getEmployeeListSuccess(data));
	} catch (error) {
		dispatch(getEmployeeListFail(getErrorMessage(error)));
	}
};
export const getEmployeeSingleDispatch = (bodyData, token) => async (dispatch) => {
	try {
		dispatch(getEmployeeSingleRequest());
		const { data } = await axiosInstance.post(
			'/Employee/GetEmployeeById',
			bodyData,
			getAxiosConfig(token)
		);
		dispatch(getEmployeeSingleSuccess(data));
	} catch (error) {
		dispatch(getEmployeeSingleFail(getErrorMessage(error)));
	}
};

export const getEmployeeFilesDispatch = (employeeid, token) => async (dispatch) => {
	try {
		dispatch(getEmployeeFileRequest());
		const { data } = await axiosInstance.get(
			`/FileUpload/getFileListByEmployeeId?empId=${employeeid}`,
			getAxiosConfig(token)
		);
		dispatch(getEmployeeFileSuccess(data));
	} catch (error) {
		dispatch(getEmployeeFileFail(getErrorMessage(error)));
	}
};



export const dowloadFtpFileDispatch = (bodyData, token) => async (dispatch) => {
	try {
		dispatch(dowloadFtpFileRequest());
		const formData = new FormData();
		for (const key in bodyData) {
			if (Object.prototype.hasOwnProperty.call(bodyData, key)) {
				formData.append(key, bodyData[key]);
			}
		}
		const headers = {
			'Content-Type': 'multipart/form-data',
			Authorization: `Bearer ${token}`, // Attach the token as required
		};
		const { data } = await axiosInstance.post(
			`/FileUpload/dowloadFtpFile`,
			bodyData,
			{ headers }
		);
		dispatch(dowloadFtpFileSuccess(data));
	} catch (error) {
		dispatch(dowloadFtpFileFail(getErrorMessage(error)));
	}
};


export const updateEmployeeDispatch = (bodyData, token, navigate) => async (dispatch) => {
	try {
		dispatch(updateEmployeeRequest());
		const { data } = await axiosInstance.post(
			`/Employee/UpdateEmployee`,
			bodyData,
			getAxiosConfig(token)
		);
		if (data.status === 1) {
			dispatch(updateEmployeeSuccess(data));
			dispatch(getEmployeeListDispatch({ Offset: 0, RecordCount: 20, EmployeeCode: '' }, token));
			dispatch(toggleEmployeeModal(false));
			if (navigate) {
				navigate('/employee/list');
			}
		} else {
			dispatch(updateEmployeeFail(data.message || 'Unable to update employee'));
		}
		return data;
	} catch (error) {
		dispatch(updateEmployeeFail(getErrorMessage(error)));
		return {
			status: 0,
			message: getErrorMessage(error),
		};
	}
};

export const deleteEmployeeDispatch = (employeeId, token) => async (dispatch) => {
	try {
		dispatch(deleteEmployeeRequest());
		await axiosInstance.delete(`/Employee/DeleteEmployeeById/${employeeId}`, getAxiosConfig(token));
		dispatch(deleteEmployeeSuccess());
	} catch (error) {
		dispatch(deleteEmployeeFail(getErrorMessage(error)));
	}
};

export const createEmployeeUserDispatch = (bodyData, token) => async (dispatch) => {
	try {
		dispatch(createEmployeeUserRequest());
		const { data } = await axiosInstance.post(
			'/User/EmployeeUserRegister',
			bodyData,
			getAxiosConfig(token)
		);

		if (data.status === 1) {
			dispatch(createEmployeeUserSuccess(data));
		} else {
			dispatch(createEmployeeUserFail(data.message || 'Unable to create employee user'));
		}

		return data;
	} catch (error) {
		const message = getErrorMessage(error);
		dispatch(createEmployeeUserFail(message));
		return {
			status: 0,
			message,
		};
	}
};
export const updateEmployeeAttachmentDispatch = (bodyData, empid, token) => async (dispatch) => {
	try {

		dispatch(insertAttachmentRequest());

		const formData = new FormData();
		for (const key in bodyData) {
			if (Object.prototype.hasOwnProperty.call(bodyData, key)) {
				formData.append(key, bodyData[key]);
			}
		}
		const headers = {
			'Content-Type': 'multipart/form-data',
			Authorization: `Bearer ${token}`, // Attach the token as required
		};

		const { data } = await axiosInstance.post(
			`/FileUpload/FTPUploadMultiple`,
			bodyData,
			{ headers }
		);
		if (data?.status === 1) {
			dispatch(insertAttachmentSuccess(data));
			dispatch(toggleFileUploadModal(false));
			dispatch(getEmployeeFilesDispatch(empid, token));
		} else {
			throw new Error(data?.message || 'File upload failed');
		}

	} catch (error) {
		dispatch(insertAttachmentFail(getErrorMessage(error)));
	}
};

export const updateEmployeeAttachmentUpdateDispatch = (bodyData, empid, token) => async (dispatch) => {
	try {

		dispatch(updateAttachmentUpdateRequest());

		const formData = new FormData();
		for (const key in bodyData) {
			if (Object.prototype.hasOwnProperty.call(bodyData, key)) {
				formData.append(key, bodyData[key]);
			}
		}

		const headers = {
			'Content-Type': 'multipart/form-data',
			Authorization: `Bearer ${token}`,
		};

		const { data } = await axiosInstance.post(
			`/FileUpload/FTPUploadMultipleUpdate`, bodyData, { headers }
		);

		if (data?.status === 1) {
			dispatch(updateAttachmentUpdateSuccess(data));
			dispatch(toggleFileUploadModal(false));
			dispatch(getEmployeeFilesDispatch(empid, token));
		} else {
			throw new Error(data?.message || 'File upload failed');
		}

	} catch (error) {
		dispatch(updateAttachmentUpdateFail(getErrorMessage(error)));
	}
};

export const fetchDepartmentsDispatch = (token) => async (dispatch) => {
	try {

		dispatch(getDepartmentListRequest());
		const { data } = await axiosInstance.get(
			'/Department/GetDepartmentList',
			getAxiosConfig(token)
		);

		dispatch(getDepartmentListSuccess(data));
	} catch (error) {
		dispatch(getDepartmentListFail(getErrorMessage(error)));
	}
};
export const fetchDesignationDispatch = (token) => async (dispatch) => {
	try {

		dispatch(getDesignationListRequest());
		const { data } = await axiosInstance.get(
			'/Designation/GetDesignationList',
			getAxiosConfig(token)
		);

		dispatch(getDesignationListSuccess(data));
	} catch (error) {
		dispatch(getDesignationListFail(getErrorMessage(error)));
	}
};


export const DeleteEmployeeFileDispatch = (bodyData, token, navigate) => async (dispatch) => {
	try {
		dispatch(deleteEmployeeFileRequest());
		const { data } = await axiosInstance.post(
			`/FileUpload/DeleteFileById`,
			bodyData,
			getAxiosConfig(token)
		);
		dispatch(deleteEmployeeFileSuccess(data));
	} catch (error) {
		dispatch(deleteEmployeeFileFail(getErrorMessage(error)));
	}
};

export const RenewEmployeeFileDispatch = (bodyData, token, navigate) => async (dispatch) => {
	try {
		dispatch(deleteEmployeeFileRequest());
		const { data } = await axiosInstance.post(
			`/FileUpload/RenewFileById`,
			bodyData,
			getAxiosConfig(token)
		);
		dispatch(deleteEmployeeFileSuccess(data));
	} catch (error) {
		dispatch(deleteEmployeeFileFail(getErrorMessage(error)));
	}
};


export const getLocationListDispatch = (token) => async (dispatch) => {
	try {
		dispatch(getEmployeeListRequest());
		const { data } = await axiosInstance.get(
			'/Location/GetLocationList',
			getAxiosConfig(token)
		);
		dispatch(getLocationListSuccess(data));
	} catch (error) {
		dispatch(getLocationListFail(getErrorMessage(error)));
	}
};

export default EmployeeReducer;
